<template>
  <div id="question" class="d-flex flex-fill">
    <div class="d-flex flex-column w-50 border-end-dashed p-4 gap-3 overflow-auto">
      <!-- begin::question -->
      <RenderQuestion :question="question"></RenderQuestion>
      <!-- end::question -->

      <!-- begin::matetials -->
      <FileList :title="$t('materials')" v-if="question.materials && question.materials.length > 0"
                :files="question.materials"></FileList>
      <!-- end::matetials -->
    </div>
    <div class="d-flex flex-column w-50 border-end-dashed p-4 gap-3 overflow-auto">
      <!-- answer input -->
      <div class="d-flex flex-column w-100 align-items-center gap-3">
        <h5 class="text-primary text-bold m-0 fs-5 text-center text-uppercase">{{ $t('your_answer') }}</h5>
        <div class="d-flex flex-column w-75 align-items-center gap-3 pb-3">
          <ol class="list-answer">
            <li class="answer-item"
                :class="{ active: answers[index].answer, correct: answers[index].is_correct == 1 && ['completed', 'over_due'].includes(assignment.state_submissions.status) && show_answer == 1, 'in-correct': answers[index].is_correct == 0 && ['completed', 'over_due'].includes(assignment.state_submissions.status)&& show_answer == 1 }"
                v-for="(answer, index) in countAnswers">
              <input type="text" class="w-100 border-0 bg-transparent" v-model="answers[index].answer"
                     :readonly="['completed', 'submitted', 'over_due'].includes(assignment.state_submissions.status)">
            </li>
          </ol>

        </div>
      </div>
      <!-- end answer input -->

      <template v-if="assignment.answer_keys && assignment.answer_keys.length > 0">
        <!-- begin::explanation -->
        <div class="d-flex flex-column w-100 align-items-center gap-3" v-if="question.explanation">
          <h5 class="text-primary text-bold m-0 fs-5 text-center text-uppercase">{{ $t('explanation') }}</h5>
          <p class="question-text" v-html="question.explanation"></p>
        </div>
        <!-- end::explanation -->

        <!-- begin::Answer key -->
        <FileList :title="$t('answer_key')" :files="assignment.answer_keys"></FileList>
        <!-- end::Answer key -->
      </template>

    </div>
  </div>
</template>
<script>
import FileList from './components/FileList';
import RenderQuestion from './components/RenderQuestion';
import {parseQuestion} from '../../utils/utils'


export default {
  name: "QuestionGapFilling",
  components: {FileList, RenderQuestion},
  props: ['question', 'assignment', 'show_answer'],
  data() {
    const initializeAnswers = parseQuestion(this.question.desc).filter(answer => answer.type === 'input').map(() => {
      return {
        answer: undefined,
        is_correct: undefined
      }
    })

    return {
      answers: (Array.isArray(this.question.submissions.answer)) ? this.question.submissions.answer : initializeAnswers,
      errors: {
        file: undefined,
      }
    }
  },
  created() {

  },

  computed: {
    countAnswers() {
      const matches = this.question.desc.match(/\[answer\]/g);
      return matches ? matches.length : 0;
    }
  },

  watch: {
    answers: {
      handler(newAnswers) {
        this.$emit('answer', this.question.id, newAnswers.map(answer => {
          return {answer: answer.answer, is_correct: 0}
        }));
      },
      deep: true
    }
  },

  methods: {}
}
</script>

<style scoped>
.border-end-dashed {
  border-right: 1px dashed #EAEAEA;
}

.question-text {
  white-space: pre-line;
}

.list-answer {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  font-size: 20px;
  font-weight: 700;
  line-height: 27.28px;
  list-style-position: outside;
}

.answer-item {
  position: relative;
  height: 52px;
  padding: 12px 20px;
  border: 1px solid #EAEAEA;
  border-radius: 8px;
  box-shadow: 0 8px 0 0 #EAEAEA;
  transition: all .3s ease-in-out;
}

.answer-item::after {
  position: absolute;
  border-bottom: 1px dashed #888888;
  left: 15px;
  bottom: 10px;
  overflow: hidden;
  width: calc(100% - 30px);
  content: '';
  pointer-events: none;
  opacity: 0.6;
}

.answer-item.active {
  background: #DBEAFE;
  border-color: #0EA5E9;
  box-shadow: 0px 8px #0EA5E9;
}

.answer-item.correct {
  background: #E8FFD8;
  border-color: #58CC02;
  box-shadow: 0px 8px #58CC02;
}

.answer-item.in-correct {
  background: #FFD6DB;
  border-color: #FF3D54;
  box-shadow: 0px 8px #FF3D54;
}
</style>